import { render, staticRenderFns } from "./addDynamicMarkup.vue?vue&type=template&id=121df7c8&scoped=true&"
import script from "./addDynamicMarkup.vue?vue&type=script&lang=js&"
export * from "./addDynamicMarkup.vue?vue&type=script&lang=js&"
import style0 from "./addDynamicMarkup.vue?vue&type=style&index=0&id=121df7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121df7c8",
  null
  
)

export default component.exports